import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const BulkActionPanel = ({ selectedCount, onAction, onClear }) => {
    const [selectedAction, setSelectedAction] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);

    const handleApply = () => {
        if (selectedAction && selectedCount > 0) {
            setShowConfirm(true);
        }
    };

    const confirmAction = () => {
        onAction(selectedAction);
        setShowConfirm(false);
    }

    return (
        <div className="d-flex align-items-center justify-content-between " >
            <div className="d-flex align-items-center">
                <span className="text-dark" style={{ fontSize: '15px' }}></span>
            </div>
            
            <div className="d-flex align-items-center gap-3">
                {selectedCount > 0 && (
                    <span 
                        className="cursor-pointer" 
                        onClick={(e) => { e.preventDefault(); onClear(); }}
                    >
                        Clear Selection
                    </span>
                )}

                <div className="mr-dropdown bulk-action-dropdown-div">
                    <select 
                        className="select-normal bot-filter-dropdown bulk-action-dropdown" 
                        onChange={(e) => setSelectedAction(e.target.value)} 
                        value={selectedAction}
                    >
                        <option value="" disabled>Select Action</option>
                        <option value="active">Activate</option>
                        <option value="inactive">Deactivate</option>
                        <option value="delete">Delete</option>
                    </select>
                </div>
                <div className='bot-detail-header-btn bulk-action-btn'> 
                    <button 
                    disabled={!selectedAction || selectedCount === 0}
                    onClick={handleApply}
                    className=""
                    style={{ 
                        opacity: (!selectedAction || selectedCount === 0) ? 0.6 : 1
                    }}
                        >
                    Apply to {selectedCount} bot(s)
                </button>
                </div>
                
            </div>
            <ConfirmDialog 
                show={showConfirm} 
                onHide={() => setShowConfirm(false)} 
                confirm={confirmAction} 
                count={selectedCount}
                action={selectedAction}
            />
        </div>
    );
};

export default BulkActionPanel;

const ConfirmDialog = (props) => {
    const { action, count, confirm, onHide, show } = props;
    const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);
    const actionText = action === 'delete' ? 'delete' : action === 'active' ? 'activate' : 'deactivate';
    
    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>Confirm {capitalize(actionText)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Please confirm that you would like to <strong>{actionText}</strong> {count} bot(s) by clicking the button below.
        </Modal.Body>
        <Modal.Footer>
          <button className={action === 'delete' ? "red-button" : "blue-button"} onClick={confirm}>
            {capitalize(actionText)}
          </button>
          <button className="grey-button" onClick={onHide}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    );
  };
